// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/Users/alex/Sites/cv/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/alex/Sites/cv/src/pages/index.js"),
  "component---src-pages-projects-js": require("gatsby-module-loader?name=component---src-pages-projects-js!/Users/alex/Sites/cv/src/pages/projects.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/alex/Sites/cv/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/Users/alex/Sites/cv/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/alex/Sites/cv/.cache/json/index.json"),
  "projects.json": require("gatsby-module-loader?name=path---projects!/Users/alex/Sites/cv/.cache/json/projects.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/Users/alex/Sites/cv/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/Users/alex/Sites/cv/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js